import React from 'react';
import Dropdown from './Dropdown';
import { DefaultDropdownProps } from './dropdownHelper';

const GenderDropdown = (props: DefaultDropdownProps) => {
  return (
    <Dropdown
      {...props}
      options={[
        { value: 'MALE', label: 'Male' },
        { value: 'FEMALE', label: 'Female' },
        { value: 'OTHER', label: 'Unspecified' },
      ]}
    />
  );
};

export default GenderDropdown;
